const initSwitchLanguage = () => {
    const langIcon = document.querySelector(".language-selector-container");
    const dropdownMenuLanguage = document.querySelector(".dropdown-lang");
    langIcon && langIcon.addEventListener('click', () => {
        if (dropdownMenuLanguage.classList.contains('is-visible')) {
            dropdownMenuLanguage.classList.remove('is-visible');
            dropdownMenuLanguage.classList.add('not-visible');
        }
        else {
            dropdownMenuLanguage.classList.remove('not-visible');
            dropdownMenuLanguage.classList.add('is-visible');
        }
    });
};
const initMobileMenu = () => {
    const header = document.querySelector(".header");
    const hamburgerIcon = document.querySelector(".hamburger-icon");
    const closeIcon = document.querySelector(".close-icon");
    const body = document.querySelector("body");
    //body.style.width = `${document.documentElement.clientWidth.toString()}px`
    if (header && hamburgerIcon && closeIcon) {
        hamburgerIcon.addEventListener("click", () => {
            closeIcon.classList.add("active");
            hamburgerIcon.classList.remove("active");
            header.classList.add("active");
            body.classList.toggle("no-scroll");
        });
        closeIcon.addEventListener("click", () => {
            closeIcon.classList.remove("active");
            hamburgerIcon.classList.add("active");
            header.classList.remove("active");
            body.classList.remove("no-scroll");
        });
        initAccordionForMobileMenu();
    }
};
const initAccordionForMobileMenu = () => {
    const accordionTogglerArray = document.querySelectorAll(".accordion-toggler-mobile");
    if (accordionTogglerArray && accordionTogglerArray.length > 0) {
        accordionTogglerArray.forEach((accordionToggler) => {
            accordionToggler.addEventListener("click", () => {
                console.log("sono il toggler");
                accordionToggler.classList.toggle("active");
                for (const sibling of accordionToggler.parentNode.children) {
                    console.log("sono il sibling");
                    console.log(sibling);
                    if (sibling.classList.contains("accordion-child-mobile")) {
                        sibling.classList.toggle('active');
                    }
                }
            });
        });
    }
};
